import { ProductUUID } from "namirasoft-api-product";
import { NSALoginPage } from "namirasoft-account-react";

function LoginPage()
{
    return (
        <NSALoginPage
            product_id={ProductUUID.NAMIRASOFT_NOTIFICATION_SENDER}
        />
    );
}

export default LoginPage;